import Vue from 'vue';
import axios from 'axios';
import VueLazyload from 'vue-lazyload';
import bcmsNav from './components/article/nav.vue';
import bcmsComment from './components/article/comment.vue';

window.axios = axios;

Vue.use(VueLazyload);
new Vue({
    el: '#main',
    components: {
        bcmsNav,
        bcmsComment,
    },
});


// WEBPACK FOOTER //
// ./resources/assets/js/web/articles.js